import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: false,
  name: 'yearMonth'
})
export class YearMonthPipe implements PipeTransform {
  transform(value: string): any {
    const dt = yearMonthToDate(value);
    if (dt) {
      return dt.toISOString();
    }
    return null;
  }
}

function yearMonthToDate(yearMonth: string): Date | null {
    if (yearMonth && yearMonth.length === 6) {
      const year = parseInt(yearMonth.substr(0, 4));
      const month = parseInt(yearMonth.substr(4, 2));
      if (!Number.isNaN(year) && !Number.isNaN(month)) {
        const date = new Date(year, month - 1);
        if (date instanceof Date && !isNaN(date.valueOf())) {
          return date;
        }
      }
    }
    return null;
  }